






import Vue from 'vue'
export default Vue.extend({
  name: 'Button',
  props: {
    link: String,
    ghost: Boolean,
    nupsi: Boolean,
    fullWidth: Boolean
  },
  computed: {
    classes: function (): any {
      return {
        'button': true,
        'button--ghost': this.ghost,
        'button--nupsi': this.nupsi,
        'button--wide': this.fullWidth
      }
    }
  }
})
